/* ============================================================
   MT — scripts propios del diseño (Glow Ritual)
   Vanilla JS. Un init por componente, todos llamados desde
   DOMContentLoaded. Cada init comprueba que su elemento existe.
   ============================================================ */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal al hacer scroll (compartido por toda la tienda) ---- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(function (el, i) {
      el.style.setProperty('--mt-delay', (i % 6) * 90 + 'ms');
      observer.observe(el);
    });
  }

  /* ---- Cifras animadas (count-up) ---- */
  function initCifras() {
    var els = document.querySelectorAll('[data-mt-cifra]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = el.getAttribute('data-mt-cifra-fin') + (el.getAttribute('data-mt-sufijo') || ''); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var fin = parseFloat(el.getAttribute('data-mt-cifra-fin')) || 0;
        var sufijo = el.getAttribute('data-mt-sufijo') || '';
        var dur = 1400;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / dur, 1);
          var actual = Math.round(fin * (1 - Math.pow(1 - progreso, 3)));
          el.textContent = actual + sufijo;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
        observer.unobserve(el);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---- Galería de producto: miniatura -> imagen principal ---- */
  function initGaleriaProducto() {
    var galeria = document.querySelector('[data-mt-galeria]');
    if (!galeria) return;
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-full');
        var alt = mini.getAttribute('data-alt') || '';
        if (!full) return;
        principal.querySelectorAll('img').forEach(function (img) {
          img.src = full;
          img.srcset = '';
          img.alt = alt;
        });
        minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
        mini.classList.add('mt-mini-activa');
      });
    });
  }

  /* ---- Selector de variantes del producto ---- */
  function initVariantesProducto() {
    var form = document.querySelector('[data-mt-form-producto]');
    if (!form) return;
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-mt-opcion]');
    var inputId = form.querySelector('[data-mt-input-id]');
    var precioEl = document.querySelector('[data-mt-precio-actual]');
    var precioCompareEl = document.querySelector('[data-mt-precio-comparado]');
    var botonComprar = form.querySelector('[data-mt-boton-comprar]');

    function moneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function actualizar() {
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, idx) { return opt === seleccion[idx]; });
      });
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioCompareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = moneda(variante.compare_at_price);
          precioCompareEl.hidden = false;
        } else {
          precioCompareEl.hidden = true;
        }
      }
      if (botonComprar) {
        if (variante.available) {
          botonComprar.disabled = false;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-disponible') || botonComprar.textContent;
        } else {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  }

  /* ---- Selector de color con swatches (página de producto) ---- */
  function initSwatchesPdp() {
    var wrap = document.querySelector('[data-mt-pdp-swatches]');
    if (!wrap) return;
    var section = wrap.closest('.mt-producto') || document;
    var swatches = wrap.querySelectorAll('[data-mt-pdp-swatch]');
    var principal = section.querySelector('[data-mt-galeria-principal]');
    var img = principal ? principal.querySelector('img') : null;
    var minis = section.querySelectorAll('[data-mt-galeria-mini]');
    var inputId = section.querySelector('[data-mt-input-id]');
    var precioEl = section.querySelector('[data-mt-precio-actual]');
    var precioCompareEl = section.querySelector('[data-mt-precio-comparado]');
    var boton = section.querySelector('[data-mt-boton-comprar]');

    function moneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) {
          s.classList.remove('mt-producto__swatch--activa');
          s.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('mt-producto__swatch--activa');
        swatch.setAttribute('aria-pressed', 'true');

        if (img) {
          var src = swatch.getAttribute('data-image');
          if (src) {
            img.src = src;
            img.srcset = '';
            img.alt = swatch.getAttribute('data-alt') || img.alt;
            var w = swatch.getAttribute('data-width');
            var h = swatch.getAttribute('data-height');
            if (w) img.setAttribute('width', w);
            if (h) img.setAttribute('height', h);
          }
        }
        minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });

        if (inputId) inputId.value = swatch.getAttribute('data-variant-id');

        var price = parseInt(swatch.getAttribute('data-price'), 10);
        var compare = parseInt(swatch.getAttribute('data-compare'), 10);
        if (precioEl && !isNaN(price)) precioEl.textContent = moneda(price);
        if (precioCompareEl) {
          if (!isNaN(compare) && compare > price) {
            precioCompareEl.textContent = moneda(compare);
            precioCompareEl.hidden = false;
          } else {
            precioCompareEl.hidden = true;
          }
        }

        if (boton) {
          var disponible = swatch.getAttribute('data-available') === 'true';
          boton.disabled = !disponible;
          boton.textContent = disponible
            ? (boton.getAttribute('data-texto-disponible') || boton.textContent)
            : (boton.getAttribute('data-texto-agotado') || 'Sold Out');
        }
      });
    });
  }

  /* ---- Selector de color con swatches (sección destacada de la portada) ---- */
  function initSwatchesCta() {
    var wrap = document.querySelector('[data-mt-cta-swatches]');
    if (!wrap) return;
    var form = wrap.closest('[data-mt-cta-form]') || document;
    var swatches = wrap.querySelectorAll('[data-mt-cta-swatch]');
    var imagenWrap = form.querySelector('[data-mt-cta-imagen]');
    var img = imagenWrap ? imagenWrap.querySelector('img') : null;
    var inputId = form.querySelector('[data-mt-cta-input-id]');
    var precioEl = form.querySelector('[data-mt-cta-precio]');
    var precioCompareEl = form.querySelector('[data-mt-cta-precio-tachado]');
    var boton = form.querySelector('[data-mt-cta-boton]');

    function moneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) {
          s.classList.remove('mt-producto-cta__swatch--activa');
          s.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('mt-producto-cta__swatch--activa');
        swatch.setAttribute('aria-pressed', 'true');

        if (img) {
          var src = swatch.getAttribute('data-image');
          if (src) {
            img.src = src;
            img.srcset = '';
            img.alt = swatch.getAttribute('data-alt') || img.alt;
            var w = swatch.getAttribute('data-width');
            var h = swatch.getAttribute('data-height');
            if (w) img.setAttribute('width', w);
            if (h) img.setAttribute('height', h);
          }
        }

        if (inputId) inputId.value = swatch.getAttribute('data-variant-id');

        var price = parseInt(swatch.getAttribute('data-price'), 10);
        var compare = parseInt(swatch.getAttribute('data-compare'), 10);
        if (precioEl && !isNaN(price)) precioEl.textContent = moneda(price);
        if (precioCompareEl) {
          if (!isNaN(compare) && compare > price) {
            precioCompareEl.textContent = moneda(compare);
            precioCompareEl.hidden = false;
          } else {
            precioCompareEl.hidden = true;
          }
        }

        if (boton) {
          var disponible = swatch.getAttribute('data-available') === 'true';
          boton.disabled = !disponible;
          boton.textContent = disponible
            ? (boton.getAttribute('data-texto-disponible') || boton.textContent)
            : (boton.getAttribute('data-texto-agotado') || 'Sold Out');
        }
      });
    });
  }

  /* ---- Comparador antes/después con deslizador ---- */
  function initComparador() {
    document.querySelectorAll('[data-mt-comparador]').forEach(function (wrap) {
      var handle = wrap.querySelector('[data-mt-comparador-asa]');
      var despues = wrap.querySelector('[data-mt-comparador-despues]');
      if (!handle || !despues) return;
      var arrastrando = false;

      function mover(clientX) {
        var rect = wrap.getBoundingClientRect();
        var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
        var pct = (x / rect.width) * 100;
        despues.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
      }

      handle.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        handle.setPointerCapture(e.pointerId);
      });
      handle.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        mover(e.clientX);
      });
      handle.addEventListener('pointerup', function () { arrastrando = false; });
      handle.addEventListener('keydown', function (e) {
        var rect = wrap.getBoundingClientRect();
        var actual = parseFloat(handle.style.left) || 50;
        if (e.key === 'ArrowLeft') mover(rect.left + (rect.width * Math.max(actual - 5, 0)) / 100);
        if (e.key === 'ArrowRight') mover(rect.left + (rect.width * Math.min(actual + 5, 100)) / 100);
      });
    });
  }

  /* ---- Acordeón FAQ ---- */
  function initFaq() {
    document.querySelectorAll('[data-mt-faq-item]').forEach(function (item) {
      var pregunta = item.querySelector('[data-mt-faq-pregunta]');
      if (!pregunta) return;
      pregunta.addEventListener('click', function () {
        var abierto = item.classList.contains('mt-faq-abierto');
        item.closest('[data-mt-faq]').querySelectorAll('[data-mt-faq-item]').forEach(function (i) {
          i.classList.remove('mt-faq-abierto');
        });
        if (!abierto) item.classList.add('mt-faq-abierto');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initCifras();
    initGaleriaProducto();
    initVariantesProducto();
    initSwatchesPdp();
    initSwatchesCta();
    initComparador();
    initFaq();
  });
})();
